import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	productionInvalid: false,
	enableActions: false, // Buttons should be enabled after user searches productions
};

const reducerMap = {
	[types.DISABLE_ACTIONS]: (state) => {
		return {
			...state,
			enableActions: false,
		};
	},
	[types.ENABLE_ACTIONS]: (state) => {
		return {
			...state,
			enableActions: true,
		};
	},
	[types.SET_PRODUCTION_VALIDITY]: (state, { payload }) => {
		return {
			...state,
			productionInvalid: payload.valid,
		};
	},
};

export default handleActions(reducerMap, initialState);
